module.exports = __webpack_public_path__ + "img/9788997918195.06f30216.jpg";